export default {
    // BASE_URL: 'http://16.16.179.217/api',
    BASE_URL: 'https://canably.dev/api',
}